@use '../../common/styles/typography.scss';
@use '../../common/styles/variables.scss';
@use '../../common/styles/functions.scss';
@use '../../common/styles/_foundation.scss';

.general-error {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  background-color: #f7f3f2;

  svg {
    color: variables.$text-light-color;
    margin-bottom: functions.toRem(18);
  }

  &__title {
    @extend .sense-font;
    font-size: typography.$font-md;
    line-height: typography.$font-md-lh;
    color: variables.$text-black-color;
    font-weight: 500;
    margin-bottom: functions.toRem(12);
  }

  &__message {
    @extend .sense-font;
    line-height: typography.$font-md-lh;
    font-size: typography.$font-md;
    padding-left: 2.75rem;
    padding-right: 1.5rem;
    text-align: center;
    color: variables.$text-light-color;
    white-space: pre-line;
  }
}
